import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackgroundInfoData.css";
import "./review.css";

const BackgroundInfoData = () => {
    const navigate = useNavigate();

    const hineData = [
        {
            date: "2th May 2025",
            color: "var(--cpa-teal, #00828A)",
            rows: [
                { label: "Timepoint", value: "6 month" },
                { label: "HINE score", value: "18" },
                { label: "Asymmetries", value: "6" },
            ]
        },
        {
            date: "10th April 2025",
            color: "var(--cpa-teal, #00828A)",
            rows: [
                { label: "Timepoint", value: "5 month" },
                { label: "HINE score", value: "60" },
                { label: "Asymmetries", value: "8" },
            ]
        },
        {
            date: "5th March 2025",
            color: "var(--cpa-purple, #5A206A)",
            rows: [
                { label: "Timepoint", value: "4 month" },
                { label: "HINE score", value: "55" },
                { label: "Asymmetries", value: "10" },
            ]
        }
    ];

    const haiData = [
        {
            date: "2th May 2025",
            color: "var(--cpa-teal, #00828A)",
            rows: [
                { label: "HAI score", value: "18" },
                { label: "Asymmetries", value: "60%" },
            ]
        },
        {
            date: "10th April 2025",
            color: "var(--cpa-teal, #00828A)",
            rows: [
                { label: "HAI score", value: "60" },
                { label: "Asymmetries", value: "80%" },
            ]
        }
    ];

    const renderCard = (item, index) => (
        <div key={index} className="bi-card">
            <div className={`bi-card-header ${item.color}`}>
                {item.date}
            </div>
            <table className="bi-card-table">
                <tbody>
                    {item.rows.map((row, idx) => (
                        <tr key={idx}>
                            <th scope="row">{row.label}</th>
                            <td>{row.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    return (
        <>
            <div className="bi-page">

                <div className="bi-header">
                    <button className="bi-back-btn" onClick={() => navigate(-1)} aria-label="Go to previous page">
                        ← Previous page
                    </button>
                    <div className="bi-title-container">
                        <h1 className="bi-title">Previous Background Information &amp; Assessments Data</h1>
                    </div>
                    <div style={{ width: '100px' }}></div>
                </div>

                <div className="bi-section">
                    <h2 className="bi-section-title">HINE score</h2>
                    <div className="bi-cards-container">
                        {hineData.map(renderCard)}
                    </div>
                </div>

                <div className="bi-section">
                    <h2 className="bi-section-title">HAI score</h2>
                    <div className="bi-cards-container">
                        {haiData.map(renderCard)}
                    </div>
                </div>
            </div>
           
        </>
    );
};

export default BackgroundInfoData;
